class DLNProductOverlays extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.roots = new Map();
    this.observer = new MutationObserver(this.schedule);
    this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-stuck', 'style', 'class', 'hidden'] });
    window.addEventListener('resize', this.schedule, { signal: this.controller.signal });
    window.addEventListener('scroll', this.schedule, { passive: true, signal: this.controller.signal });
    this.schedule();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    for (const observer of this.roots?.values() ?? []) observer.disconnect();
    cancelAnimationFrame(this.frame);
    document.querySelector('.sticky-add-to-cart__bar')?.removeAttribute('data-dln-overlay-blocked');
  }

  schedule = () => {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = 0;
      if (!this.isConnected) return;
      const bar = document.querySelector('.sticky-add-to-cart__bar');
      if (!bar) return;
      let bounds = bar.getBoundingClientRect();
      if (bar.dataset.stuck === 'true') {
        // Use the resting position during the native entrance transition.
        const bottom = innerHeight - (parseFloat(getComputedStyle(bar).bottom) || 0);
        bounds = { left: bounds.left, right: bounds.right, top: bottom - bounds.height, bottom };
      }
      let blocked = false;
      for (const host of document.querySelectorAll('shopify-forms-embed')) {
        const root = host.shadowRoot;
        if (!root) continue;
        if (!this.roots.has(root)) {
          const observer = new MutationObserver(this.schedule);
          observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
          this.roots.set(root, observer);
        }
        // Measure the app's rendered containers; never modify its form, fields or settings.
        for (const container of root.children) {
          if (!(container instanceof HTMLElement)) continue;
          const rect = container.getBoundingClientRect();
          const style = getComputedStyle(container);
          if (rect.width && rect.height && style.display !== 'none' && style.visibility !== 'hidden' &&
              rect.top < bounds.bottom && rect.bottom > bounds.top && rect.left < bounds.right && rect.right > bounds.left) blocked = true;
        }
      }
      for (const [root, observer] of this.roots) if (!root.host.isConnected) { observer.disconnect(); this.roots.delete(root); }
      if (bar.dataset.dlnOverlayBlocked !== String(blocked)) bar.dataset.dlnOverlayBlocked = String(blocked);
    });
  };
}
if (!customElements.get('dln-product-overlays')) customElements.define('dln-product-overlays', DLNProductOverlays);
